export enum ConditionEnum {
    String,
    Numerico,
    Money,
    Data,
    Bool,
    Situacao,
    TipoEntradaSaida,
    NivelAcesso,
    Tipo,
    Destino,
    TipoPessoa,
}